import {
  IonList,
  IonListHeader,
} from '@ionic/react';
import React, { useRef, useEffect } from 'react';
import { Shipping } from '../models/Shipping';
import ShippingListItem from './ShippingListItem';

interface OwnProps {
  shippings: Shipping[];
}

interface StateProps {
}

interface ShippingListProps extends OwnProps, StateProps {}

const ShippingList: React.FC<ShippingListProps> = ({
  shippings,
}) => {
  const shippingListRef = useRef<HTMLIonListElement>(null);

  useEffect(() => {
    if (shippingListRef.current) {
      shippingListRef.current.closeSlidingItems();
    }
  }, []);

  if (shippings.length === 0) {
    return (
      <IonList>
        <IonListHeader>データがありません。</IonListHeader>
      </IonList>
    );
  }

  return (
    <>
      <IonList ref={shippingListRef}>
        {shippings.map((record, index: number) => (
          <ShippingListItem
            key={`record-${index}`}
            shipping={record}
          />
        ))}
      </IonList>
    </>
  );
};

export default ShippingList;
